import { FC } from 'react'
import { Squares2X2Icon, CalendarDaysIcon, LinkIcon, ChartBarIcon } from '@heroicons/react/24/outline'
import { CategoryMetaData } from '../../categoryDashboard.types'
import { MetaDataWrapper, SkeletonBar } from './metaDataSection.styles'
import { MetaDataIcon, InfoIcon } from '../icons'
import OnyxiaTooltip from 'ui/components/tooltip/OnyxiaTooltip'
import theme from 'theme'

interface Props {
  data?: CategoryMetaData
  loading?: boolean
}

const SKELETON_WIDTHS = ['209px', '96px', '121px', '124px']

const MetaDataSection: FC<Props> = ({ data, loading }) => {
  const items = [
    {
      icon: <Squares2X2Icon />,
      label: 'Category weight',
      value: data?.weight,
      hasInfo: true
    },
    {
      icon: <CalendarDaysIcon />,
      label: 'Date activated',
      value: data?.dateActivated,
      hasInfo: false
    },
    {
      icon: <LinkIcon />,
      label: 'Active integrations',
      value: data ? String(data.activeIntegrations) : undefined,
      hasInfo: false
    },
    {
      icon: <ChartBarIcon />,
      label: 'Active CPIs',
      value: data ? String(data.activeCPIs) : undefined,
      hasInfo: false
    }
  ]

  return (
    <MetaDataWrapper>
      <div className="section-title">
        <MetaDataIcon className="title-icon" />
        <span className="title-text">Meta Data</span>
      </div>
      <div className="meta-items">
        {items.map((item, index) => (
          <div className="meta-item" key={index}>
            <div className="icon-box">{item.icon}</div>
            <div className="meta-content">
              <div className="meta-label">
                {item.label}
                {item.hasInfo && (
                  <OnyxiaTooltip
                    title="How important this category is in your overall security score. Higher weight means a stronger impact on performance and benchmarking results."
                    placement="bottom-start"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          color: `${theme.colors.devicesSecondaryText} !important`,
                          maxWidth: '272px !important',
                          width: '272px !important',
                          marginLeft: '20px !important'
                        }
                      }
                    }}
                  >
                    <span className="info-icon-wrapper">
                      <InfoIcon />
                    </span>
                  </OnyxiaTooltip>
                )}
              </div>
              {loading || !item.value ? (
                <SkeletonBar width={SKELETON_WIDTHS[index]} />
              ) : (
                <div className="meta-value">{item.value}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </MetaDataWrapper>
  )
}

export default MetaDataSection
